if (!customElements.get('product-form')) {
  window.sampleProductCartState = window.sampleProductCartState || {
    promise: null,
  };

  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
            getMaxQuantity() {
              // Try to get the max attribute from the quantity input in this form
              const quantityInput = this.form.querySelector('input[name="quantity"]');
              if (quantityInput && quantityInput.hasAttribute('max')) {
                const max = parseInt(quantityInput.getAttribute('max'));
                if (!isNaN(max)) {
                  return max;
                }
              }
              return null;
            }
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.productTitle = (this.dataset.productTitle || '').toLowerCase();
        this.isSampleProduct = this.productTitle.includes('sample');
        this.baseDisabledState = this.submitButton.hasAttribute('disabled');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.isSampleProduct) {
          this.syncSampleCartLimit();

          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
            this.syncSampleCartLimit(true);
          });
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
          this.cartUpdateUnsubscriber = null;
        }
      }

      fetchCartState(forceRefresh = false) {
        if (forceRefresh) {
          window.sampleProductCartState.promise = null;
        }

        if (!window.sampleProductCartState.promise) {
          window.sampleProductCartState.promise = fetch(`${routes.cart_url}.js`, {
            headers: {
              Accept: 'application/json',
            },
          })
            .then((response) => response.json())
            .catch(() => ({ items: [] }));
        }

        return window.sampleProductCartState.promise;
      }

      async syncSampleCartLimit(forceRefresh = false) {
        if (!this.isSampleProduct || !this.submitButton || !this.variantIdInput) return;

        const currentVariantId = Number(this.variantIdInput.value);
        if (!currentVariantId) return;

        const cartState = await this.fetchCartState(forceRefresh);
        const cartItems = Array.isArray(cartState?.items) ? cartState.items : [];
        const sampleVariantInCart = cartItems.some((item) => Number(item.id) === currentVariantId && item.quantity >= 1);

        if (sampleVariantInCart) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.dataset.sampleLimitReached = 'true';
          return;
        }

        if (!this.baseDisabledState) {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButton.getAttribute('aria-disabled') === 'true') {
            this.submitButton.removeAttribute('aria-disabled');
          }
        }

        delete this.submitButton.dataset.sampleLimitReached;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.isSampleProduct) {
          await this.syncSampleCartLimit(true);
        }

        if (this.submitButton.dataset.sampleLimitReached === 'true') return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              console.log('cart error max stock reached');

              // Show exceed stock modal if error message is about exceeding stock
              if (response.description && response.description.toLowerCase().includes('max') || response.description.toLowerCase().includes('winkelwagen')) {
                var modal = document.getElementById('exceed-stock-modal');
                if (modal) {
                  // get max quantity
                  
                  let exceedModalTitle = document.getElementById('exceed-stock-title');
                  let exceedModalText = document.getElementById('exceed-stock-message');
                  let stockCount = document.getElementById('stockSpecs');
                  if (exceedModalTitle && exceedModalText) {
                    exceedModalText.innerHTML = "<p>Helaas is de beschikbare voorraad beperkt. Er zijn daarom (" + stockCount.innerText + ") producten aan uw winkelwagen toegevoegd. Wilt u meer producten bestellen? Neem gerust <a class='underline decoration-solid text-[var(--fthBlue)] font-semibold' href='/pages/contact'>contact met ons op</a>, dan bekijken wij graag wat wij voor u kunnen betekenen.</p>";
                  }

                  modal.style.display = 'flex';
                  modal.style.setProperty('display', 'flex', 'important');
                  modal.style.zIndex = '99999';
                  var closeBtn = document.getElementById('close-exceed-stock-modal');
                  if (closeBtn) {
                    closeBtn.onclick = function() {
                      modal.style.display = 'none';
                      window.suppressCartDrawerRefresh = true;
                    };
                  }
                }
              }

              // Only refresh cart drawer if not suppressed by modal close
              if (!window.suppressCartDrawerRefresh) {
                const sectionsToRender = this.cart.getSectionsToRender().map((section) => section.id);
                fetch(`${window.routes.cart_url}?sections=${sectionsToRender.join(',')}`)
                  .then((cartResponse) => cartResponse.json())
                  .then((cartData) => {
                    // Wrap sections in the expected format
                    this.cart.renderContents({ sections: cartData });
                  })
                  .catch((e) => {
                    console.error('Failed to update cart drawer:', e);
                  });
              } else {
                // Reset the flag for next time
                window.suppressCartDrawerRefresh = false;
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
